import { Link } from "react-router-dom";
import React, { useEffect, useRef, useState } from "react";
import Constants from "../utils/constants";
import { useAPIs } from "../apis/APIsConfig";
import { useForm } from "../utils/hooks";
import WithLoginLayout from "../hocs/layouts/LoginLayout";
import { recoverPass } from "../services/user";
import axios from "axios";
import InputMask from "react-input-mask";
import Reaptcha from "reaptcha";

const RecoverPassword = () => {
  useAPIs();

  var captchaRef;

  const [succeed, setSucceed] = useState(false);
  const [formState, setError, changeHandler, reset] = useForm({
    cedula: "",
    captcha: false,
  });

  useEffect(() => {
    setSucceed(false);
    changeHandler("captcha", false)();
    captchaRef?.reset();
  }, []);

  function disableButton() {
    return (
      formState.data.cedula.replaceAll("_", "").length !== 11 ||
      !formState.data.captcha
    );
  }

  function submitForm() {
    axios.get("https://api.ipify.org/?format=json").then((resIP) => {
      recoverPass(formState.data.cedula, resIP.data.ip).then((res) => {
        if (res && res.data) {
          setSucceed(res.data.successed);
        }
      });
    });

    changeHandler("captcha", false)();
    captchaRef?.reset();
  }

  function onVerify(recaptchaResponse) {
    changeHandler("captcha", true)();
  }

  return (
    <>
      {!succeed && (
        <>
          <Link
            to={Constants.APPURLS.LOGIN}
            className="btn btn-secondary btn-medium"
          >
            <i className="icon icon-arrow-leftv-short right"></i>Volver
          </Link>

          <div className="block pt-6 md:pt-14 pb-10">
            <h1 className="text-primary-100 font-bold mb-2">
              Recuperar Contraseña
            </h1>
            <p className="text-gray-70 text-body-1 font-body font-normal">
              Antes de continuar favor de{" "}
              <span className="font-semibold">
                ingresar su número de cédula
              </span>
            </p>
          </div>
          <form
            className="block space-y-8"
            onSubmit={(e) => {
              e.preventDefault();
            }}
          >
            <div className="form-group">
              <label>Documento de Identidad</label>
              <InputMask
                type="text"
                className="form-control large"
                placeholder="Ingresa tu documento"
                value={formState.data.cedula}
                onChange={changeHandler("cedula", undefined, "-")}
                mask="999-9999999-9"
                maskPlaceholder={"_"}
              />
            </div>
            <Reaptcha
              ref={(e) => (captchaRef = e)}
              sitekey={process.env.REACT_APP_SITE_KEY}
              onVerify={onVerify}
            />
            <button
              type="button"
              onClick={submitForm}
              disabled={disableButton()}
              className="btn btn-primary btn-large w-full"
            >
              Continuar
            </button>
          </form>
        </>
      )}
      {succeed && (
        <div className="block text-center">
          <div className="w-20 h-20 rounded-full border-2 border-primary-90 p-2 mx-auto mb-10">
            <i className="icon icon-check  rounded-full bg-primary-20 text-primary-100 text-[20px] w-full h-full flex items-center justify-center"></i>
          </div>
          <h1 className="text-primary-100 font-bold mb-2">Solicitud Enviada</h1>
          <p className="text-gray-70 text-body-1 font-body font-normal mb-12">
            Hemos recibido tu solicitud, en las próximas horas te estaremos{" "}
            <br className="hidden md:block" /> enviando un correo a tu email con
            los datos para tu ingreso.{" "}
          </p>
          <Link
            to={Constants.APPURLS.LOGIN}
            className="btn btn-primary btn-large px-4 md:px-[112px]"
          >
            Ir a Inicio de Sesión
          </Link>
        </div>
      )}
    </>
  );
};

export default WithLoginLayout(RecoverPassword);
